@use "@fukuri-admins/ui/layout" as *;

.formContainer {
  display: flex;
  flex-direction: column;
  gap: spacing("16");
  margin-top: spacing("24");
  width: 100%;
}
